

















import { Component, Prop, Mixins } from 'vue-property-decorator'

import ItemTile from '@/components/ItemTile.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    ItemTile
  },
  apollo: {
  }
})
export default class extends Mixins(Common) {
  @Prop() readonly items!: object[]
}
